import React from 'react';
import styled from 'styled-components';

const HelpDialogTraning1 = (props) => {
    return(
        <React.Fragment>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <b>☆トレーニングガイドは<a href="https://englishcompany-mobile.jp/guide/" target="_blank" rel="noopener noreferrer">こちら</a>☆</b>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />

            <h2>STEP1. 一度だけリスニング</h2>

            再生ボタンをタップすると英語音声が流れます。まずは音声を一度だけ聞きましょう。<br />
            
            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>音声を聞きながら内容をできるだけ覚える</Text></Texts>
            <Texts><Text>✓ </Text><Text>途中で音声を止めない</Text></Texts>

            <h2>STEP2. 理解度のチェック</h2>

            聞き終わったら、「わかったこと」を声に出して説明してみましょう。<br />
            
            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>「わかったつもり」を防ぐために、実際に言葉にして説明する</Text></Texts>
            <Texts><Text>✓ </Text><Text>この段階では全部わからなくても大丈夫</Text></Texts>
            <Texts><Text>✓ </Text><Text>完璧に理解できるようであれば教材の難易度を上げる</Text></Texts>
        </React.Fragment>
    );
}

export { HelpDialogTraning1 };

const Texts = styled.span`
    display: flex;
`;

const Text = styled.span`
    margin: 0;
`;
